export default __webpack_public_path__ + "static/media/g2-logo.f9152f1f.svg";